import React from 'react'
import { getNextUuid } from '@fs/zion-sls'
import { Checkbox, CheckboxGroup, Divider, Separator } from '@fs/zion-ui'
import { useFormState } from '@fs/zion-form'

const FactOptionGroup = ({ facts, groupLabel, filterText, fieldArrayMethods }) => {
  const { defaultValues } = useFormState()
  const searchStr = filterText.toLowerCase()
  const filteredFacts = facts.filter((fact) => fact.label.toLowerCase().includes(searchStr))

  const onCheckboxChange = (fact) => {
    const existingField = fieldArrayMethods.fields.find((field) => field.key === fact.value)
    if (existingField) {
      const index = fieldArrayMethods.fields.indexOf(existingField)
      fieldArrayMethods.remove(index)
    } else {
      const originalExistingField = defaultValues.additionalFacts?.find((field) => field.key === fact.value)

      fieldArrayMethods.append(
        originalExistingField || {
          label: fact.label,
          value: '',
          key: fact.value,
          id: getNextUuid(),
          editable: true,
          locked: false,
          added: true,
          dispatches: [],
        }
      )
    }
  }

  return (
    <CheckboxGroup label={groupLabel}>
      <Divider />
      {filteredFacts.map((fact) => (
        <div key={fact.value}>
          <Separator size="nano" />
          <Checkbox
            value={fact.value}
            name={fact.value}
            label={fact.label}
            checked={Boolean(fieldArrayMethods.fields.find((field) => field.key === fact.value))}
            onChange={() => onCheckboxChange(fact)}
          />
        </div>
      ))}
    </CheckboxGroup>
  )
}
export default FactOptionGroup
